import { createBooleanQueryParamState } from './manager';

export const isExportModalOpenGlobalState = createBooleanQueryParamState('export', false);
